export default __webpack_public_path__ + "static/media/undraw_Note_list_re_r4u9.b1a76463.png";